<template>
    <div
        class="search-result-company-scan"
        data-bot="search-result__company-scan"
        :class="classes"
        @mouseenter="handleMouseEnter"
        @mouseleave="isHovered = false"
    >
        <CompassObject size="extra-small" type="object" object="company" />
        <div class="search-result-company-scan__content">
            <div class="search-result-company-scan__title">
                <h5
                    class="search-result-company-scan__name typographies-paragraph-medium-bold"
                    v-html="name"
                />
            </div>
            <ul class="search-result-company-scan__details typographies-paragraph-medium-regular">
                <li>{{ formatAddress }}</li>
                <li v-if="siret" class="search-result-company-scan__address">{{ siret }}</li>
            </ul>
        </div>
        <CompassButton
            :label="$t.__('common.actions.add')"
            type="tertiary"
            leftIcon="plus"
            @click="handleSelect"
        />
    </div>
</template>
<script>
import SearchResultsGeneric from './SearchResultsGeneric.vue';

export default {
    extends: SearchResultsGeneric,
    props: {
        address: {
            type: Object,
            default: () => {},
        },
        name: {
            type: String,
            required: true,
        },
        siret: {
            type: String,
            default: '',
        },
    },
    computed: {
        classes() {
            return {
                'search-result-company-scan--is-hovered': this.isHovered,
            };
        },
        formatAddress() {
            return `${this.address.postal_code} ${this.address.city}`;
        },
    },
    methods: {
        handleSelect() {
            this.$emit('createCompany', {
                name: this.name,
                address: this.address,
                siret: this.siret,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.search-result-company-scan {
    align-items: center;
    display: flex;
    gap: var(--spacing-1);
    padding: var(--spacing-1) var(--spacing-3);

    &--is-hovered {
        background: var(--colors-common-background-hover, #f6f6f9);
    }

    :deep(.compass-object) {
        align-self: flex-start;
    }

    &__title {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
    }

    &__name {
        color: var(--colors-common-text-standard-default, #111);
        margin: 0;
    }

    &__details {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        gap: var(--spacing-2);
        margin: var(--spacing-0) 0 0;
    }

    &__address {
        color: var(--colors-common-text-standard-caption, #8c909c);
    }

    :deep(.compass-button) {
        margin-left: auto;
    }
}
</style>
